import React, { forwardRef, ComponentProps, ReactNode } from 'react';
import styles from './a11y-image.module.scss';

type Props = {
    src: string;
    altText: ReactNode;
} & ComponentProps<'img'>;

const A11yImage = forwardRef<HTMLImageElement, Props>(
    ({ src, altText, className, ...rest }, ref) => {
        if (!altText) {
            console.warn('altText not specified');
        }

        if (!src) return null;

        /* eslint-disable no-restricted-syntax */
        return (
            <img
                ref={ref}
                src={src}
                alt={altText as string}
                className={className || styles.a11yImage}
                {...rest}
            />
        );
    }
);

A11yImage.displayName = 'A11yImage';

export default A11yImage;
